import { render } from "./AppResources.vue?vue&type=template&id=60f9ac6b&scoped=true"
import script from "./AppResources.vue?vue&type=script&lang=js"
export * from "./AppResources.vue?vue&type=script&lang=js"

import "./AppResources.vue?vue&type=style&index=0&id=60f9ac6b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60f9ac6b"]])

export default __exports__